<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="bg-gray-50">
    <main class="mx-auto">
      <div>
        <!-- 内容区 -->
        <div class="w-full">
          <div class="bg-white rounded-lg shadow-sm p-8 transition-all hover:shadow-md">
            <div class="flex items-center text-gray-500 text-sm mb-4">
              <a-breadcrumb>
                <a-breadcrumb-item>
                  <span class="ml-1">首页</span>
                </a-breadcrumb-item>
                <a-breadcrumb-item>
                  <span class="ml-1" @click="goquestion" style="cursor: pointer;">常见问题</span>
                </a-breadcrumb-item>
                <a-breadcrumb-item>{{ detail.title }}</a-breadcrumb-item>
              </a-breadcrumb>
            </div>
            <h2 class="text-2xl font-semibold mb-4 text-gray-900">{{ detail.title }}</h2>
            <div class="flex justify-center items-center text-gray-500 text-sm mb-8 space-x-8 border-b border-gray-100 pb-6">
              <div class="flex items-center justify-center">
                <span>发布时间: {{ detail.publishTime }}</span>
              </div>
              <div class="flex items-center justify-center">
                <span>作者: {{ detail.author }}</span>
              </div>
              <div class="flex items-center justify-center">
                <span>阅读量: {{ detail.readCount }}</span>
              </div>
            </div>
            <div class="prose max-w-none">
              <div class="bg-gray-50 border-l-4 border-blue-500 p-4 mb-8">
                <p class="text-gray-600 leading-relaxed">{{ detail.description }}</p>
              </div>
              <div class="space-y-8" v-html="detail.content"> 
              </div>
              <div class="mt-12 p-6 bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-lg border border-blue-100">
                <h3 class="text-lg font-medium mb-4 items-center">
                  温馨提示
                </h3>
                <p class="text-gray-600 leading-relaxed">
                  如果您在设置过程中遇到任何问题，请随时联系我们的客服团队。我们的专业人员将为您提供一对一的帮助，确保您的账户安全无忧。
                </p>
                <div class="mt-6 items-center space-x-4">
                  <a-button type="primary" size="large" class="!rounded-button whitespace-nowrap font-medium hover:opacity-90 transition-opacity" @click="kefu()">
                    在线咨询
                  </a-button>
                  <a-button @click="kefu()" size="large" class="!rounded-button whitespace-nowrap font-medium border-gray-300 hover:border-blue-400 hover:text-blue-500 transition-colors">
                    电话支持
                  </a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';
import kfsrc from '@/assets/images/kefu2.jpg'

export default {
  name: 'HelpPageDetail',
  data() {
    return {
      detail: {
        title: '',
        publishTime: '',
        author: '',
        readCount: 0,
        description: '',
        content: ''
      }
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    kefu() {
      console.log('1111', this.kfsrc)
      const h = this.$createElement;
      this.$info({
        title: '添加客服微信：dcapp001 或 dczskf02',
        content: h('div', {}, [
          h('img', { attrs: { src: kfsrc }, style: { width: '270px' } }),
        ]),
        onOk() { },
      });
    },
    goquestion(){
        this.$router.push({
          path: '/help_question'
        });
    },
    async getDetail() {
      try {
        const id = this.$route.query.id;
        if (!id) {
          this.$message.error('参数错误');
          return;
        }
        const { code, msg, data } = await requestHttp({
          api: qcApi.GET_QUESTION_DETAIL,
          method: 'POST',
          params:{
            id:id
          }
        })
        if (code === 1) {
          this.detail = {
            title: data.title,
            publishTime: data.createtime,
            author: data.author,
            readCount: data.views,
            description: data.descriptions,
            content: data.content // 富文本内容
          };
        } else {
          this.$message.error(msg || '获取详情失败');
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      }
    }
  }
};
</script>

<style scoped>
.ant-input-search .ant-input {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  padding-left: 36px;
}
.ant-input-search .ant-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.ant-collapse {
  background: #fff;
  border: none;
}
.ant-collapse-item {
  border-bottom: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}
.ant-collapse-item:hover {
  background-color: #f8fafc;
}
.ant-collapse-header {
  font-weight: 500;
  padding: 16px 0 !important;
}
.ant-collapse-content {
  border-top: none;
}
.ant-collapse-content-box {
  padding: 0 0 16px 0 !important;
}
.ant-breadcrumb a:hover {
  color: #3b82f6;
}
.mainContent{
  background: none !important;
}

/* 富文本内容样式 */
:deep(.space-y-8) {
  h1 {
    @apply text-2xl font-bold mb-4;
  }
  h2 {
    @apply text-xl font-bold mb-3;
  }
  h3 {
    @apply text-lg font-bold mb-2;
  }
  p {
    @apply text-gray-600 leading-relaxed mb-4;
  }
  ul {
    @apply list-disc pl-5 mb-4;
  }
  ol {
    @apply list-decimal pl-5 mb-4;
  }
  li {
    @apply mb-2;
  }
  img {
    @apply max-w-full rounded-lg my-4;
  }
  table {
    @apply w-full border-collapse mb-4;
  }
  th, td {
    @apply border border-gray-200 p-2;
  }
  a {
    @apply text-blue-500 hover:text-blue-600 underline;
  }
  blockquote {
    @apply border-l-4 border-gray-200 pl-4 italic my-4;
  }
  pre {
    @apply bg-gray-50 p-4 rounded-lg overflow-x-auto my-4;
  }
  code {
    @apply bg-gray-50 px-1 py-0.5 rounded;
  }
}
</style>
  